import { createFileRoute } from '@tanstack/react-router';

import { getChapterOptions } from '@/module/Author/Chapter';

export const Route = createFileRoute(
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout',
)({
  loader: async ({ params: { chapterId }, context: { queryClient } }) => {
    const chapter = await queryClient.ensureQueryData(getChapterOptions(chapterId));

    return {
      chapter,
      crumb: chapter.title,
    };
  },
});
